import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

const Cycling = ({ width = 145, height = 118 }) => {
  const theme = useTheme();
  const colorPrimaryMain = theme.palette.primary.main;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 145 118"
    >
      <path
        fill="#FFD200"
        d="M79.395 81.866l-7.547 5.02 1.62 2.436 7.547-5.02-1.62-2.436z"
      ></path>
      <path
        fill="#F4A28C"
        d="M73.305 58.176l-2.07 1.395a6.84 6.84 0 00-2.46 8.35l5.19 12.18 3.5-1.24-1.035-16.705-3.125-3.98z"
      ></path>
      <path
        fill="#000"
        d="M73.305 58.176l-2.07 1.395a6.84 6.84 0 00-2.46 8.35l5.19 12.18 3.5-1.24-1.035-16.705-3.125-3.98z"
        opacity="0.08"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M73.374 78.64s.245 3.32-2.24 4.69c-2.485 1.37-2.035 4.2.58 3.826C74.33 86.78 79 81.116 79 81.116l-1.83-3.655-3.795 1.18z"
      ></path>
      <path
        fill="#245B5B"
        d="M82.65 51.56l-9.974 5.816 3.75 4.78 10.1-10.276-3.875-.32zM27.46 55.274S21 54.5 21 57.344c0 2.845 1.325 6.46 8.25 2.405l-1.79-4.475z"
      ></path>
      <path
        fill="#F4A28C"
        d="M54.596 14.115s-8.5.74-9.605 9.285c-1.105 8.545 2.584 25.37 2.584 25.37l-20.47 6.555 1.79 4.47 19.926-2.17a11 11 0 009.105-7.045C62 39.83 67.94 18.745 54.596 14.115z"
      ></path>
      <path
        fill="#000"
        d="M54.596 14.115s-8.5.74-9.605 9.285c-1.105 8.545 2.584 25.37 2.584 25.37l-20.47 6.555 1.79 4.47 19.926-2.17a11 11 0 009.105-7.045C62 39.83 67.94 18.745 54.596 14.115z"
        opacity="0.08"
      ></path>
      <path
        fill="#E6E6E6"
        d="M77.39 117.835c36.812 0 66.654-3.777 66.654-8.435 0-4.659-29.842-8.435-66.655-8.435-36.812 0-66.655 3.776-66.655 8.435 0 4.658 29.843 8.435 66.655 8.435z"
        opacity="0.45"
      ></path>
      <path
        fill="#F4A28C"
        d="M34 7.45s.34 3.966 1.445 6.446a2 2 0 002.65 1c1.245-.575 2.755-1.715 2.83-3.86L41.5 7.41a3.574 3.574 0 00-2.205-3.5C36.83 2.716 33.69 5.05 34 7.45z"
      ></path>
      <path
        fill="#F4A28C"
        d="M39.795 7.775L50.9 14.59l-4.19 5.85-6.24-7.12-.675-5.545z"
      ></path>
      <path
        fill="#245B5B"
        d="M33.785 7.414a3.79 3.79 0 001.235.03 15.916 15.916 0 003.56-.905 3.32 3.32 0 00.625 3.585c1.55 1.665 4.115-.19 4.115-.19l-1.655-4.33A4.055 4.055 0 0039 2.4a13.952 13.952 0 00-1.82-.53"
      ></path>
      <path
        fill="#F4A28C"
        d="M38.766 10.08s-.235-1.5.92-1.595c1.155-.095 1.5 2.105 0 2.575l-.92-.98zM34.36 9.936l-.83 1.7a.635.635 0 00.565.915l1.55.024-1.285-2.64z"
      ></path>
      <path
        fill="#CE8172"
        d="M40.47 13.316s.856-1.185.63-2.355c0 0 2.56 1.26 1.336 4.6l-1.965-2.245z"
        opacity="0.31"
      ></path>
      <path
        fill="#FFD200"
        d="M31.145 6.736a1.735 1.735 0 001.854 1.73 15.03 15.03 0 005.386-1.295 76.569 76.569 0 003.69-1.875 1.23 1.23 0 00.384-1.825 2.3 2.3 0 01-.19-2.53l.166-.295A.41.41 0 0042.08.03C39.594 0 31.22.46 31.145 6.736z"
      ></path>
      <path
        fill="#fff"
        d="M38 7.35a11.646 11.646 0 001.6 6.594l.65-.27a11.86 11.86 0 01-1.5-6.68L38 7.35z"
      ></path>
      <path
        fill="#fff"
        d="M40.47 6.14s1.21 4.696-1.374 5.44l.235.56s2.915-.374 1.71-6.294l-.57.295z"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M106 109.129a16.129 16.129 0 1116.125-16.13A16.146 16.146 0 01106 109.13zm0-30.18A14.056 14.056 0 10120.05 93 14.068 14.068 0 00106 78.95zM48.925 110a16.127 16.127 0 01-14.903-9.958 16.13 16.13 0 1131.033-6.167A16.144 16.144 0 0148.925 110zm0-30.18A14.056 14.056 0 1063 93.875 14.07 14.07 0 0048.925 79.82z"
      ></path>
      <path
        fill="#245B5B"
        d="M48.924 111.5a17.633 17.633 0 01-17.296-21.075 17.635 17.635 0 0134.931 3.44A17.654 17.654 0 0148.924 111.5zm0-33a15.37 15.37 0 1015.37 15.37 15.385 15.385 0 00-15.37-15.37zM106 110.639a17.636 17.636 0 01-16.3-10.886A17.64 17.64 0 11123.635 93 17.658 17.658 0 01106 110.64zm0-33a15.369 15.369 0 00-2.999 30.446 15.37 15.37 0 0018.364-15.086A15.381 15.381 0 00106 77.634v.005z"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M45.34 16.88s3-9.08 19.155-6.41 34.315 16.4 34.55 35.94l-15.22 6.65S75.45 40.615 62.54 44.34C49.63 48.065 34.645 34 45.34 16.88zM106.624 93.095l-14-21.07a.765.765 0 00-.57-.335l3.86-10.225a.757.757 0 00-1.415-.535l-2.725 7.225c-9.945-3.61-26.83-4.06-30.5-4.115.063-.797.074-1.597.035-2.395a2.03 2.03 0 00-2.03-2H54.5a5.56 5.56 0 00-3.975 1.61 4.17 4.17 0 00-1.2 3.67c.555 3.55 3.405 4.845 4.62 4.89a.755.755 0 10.06-1.5c-.41 0-2.74-.75-3.19-3.615a2.645 2.645 0 01.79-2.38 4.05 4.05 0 012.895-1.155h4.76a.501.501 0 01.37.155.499.499 0 01.145.37.356.356 0 000 .07c0 .125.835 12.73-11.5 29.925a.755.755 0 00.615 1.195.746.746 0 00.615-.315c5.785-8.075 8.75-15.11 10.26-20.425L82.5 94.06a.75.75 0 00.5.215h23a.757.757 0 00.752-.793.756.756 0 00-.127-.382v-.005zm-45.5-27.545c3.325.055 20.415.5 30.125 4l-8.525 22.6-22.5-21.735c.405-1.601.709-3.226.91-4.865h-.01zm23 27.21L91.54 73.1l13.045 19.66h-20.46z"
      ></path>
      <path
        fill="#fff"
        d="M106.624 93.095l-14-21.07a.765.765 0 00-.57-.335l3.86-10.225a.757.757 0 00-1.415-.535l-2.725 7.225c-9.945-3.61-26.83-4.06-30.5-4.115.063-.797.074-1.597.035-2.395a2.03 2.03 0 00-2.03-2H54.5a5.56 5.56 0 00-3.975 1.61 4.17 4.17 0 00-1.2 3.67c.555 3.55 3.405 4.845 4.62 4.89a.755.755 0 10.06-1.5c-.41 0-2.74-.75-3.19-3.615a2.645 2.645 0 01.79-2.38 4.05 4.05 0 012.895-1.155h4.76a.501.501 0 01.37.155.499.499 0 01.145.37.356.356 0 000 .07c0 .125.835 12.73-11.5 29.925a.755.755 0 00.615 1.195.746.746 0 00.615-.315c5.785-8.075 8.75-15.11 10.26-20.425L82.5 94.06a.75.75 0 00.5.215h23a.757.757 0 00.752-.793.756.756 0 00-.127-.382v-.005zm-45.5-27.545c3.325.055 20.415.5 30.125 4l-8.525 22.6-22.5-21.735c.405-1.601.709-3.226.91-4.865h-.01zm23 27.21L91.54 73.1l13.045 19.66h-20.46z"
        opacity="0.26"
      ></path>
      <path
        fill="#FFD200"
        d="M103.284 58.176H91.469c-.72 0-1.305.584-1.305 1.305v.415c0 .72.584 1.305 1.305 1.305h11.815c.721 0 1.305-.584 1.305-1.305v-.415c0-.721-.584-1.305-1.305-1.305z"
      ></path>
      <path
        fill="#000"
        d="M66.885 18.5s18.37 6.25 24.375 31.31l-7.435 3.245s-3-4.07-6.31-6.11c-3.31-2.04-7.145-8.5-7.145-8.5L66.885 18.5z"
        opacity="0.08"
      ></path>
      <path
        fill="#245B5B"
        d="M80.114 98.45a5.875 5.875 0 01-5.87-5.88 5.875 5.875 0 016.325-5.865l28.265 2.15a4.105 4.105 0 01-.11 8.19l-28.31 1.395-.3.01zm0-10.84a4.958 4.958 0 00-3.398 8.62 4.96 4.96 0 003.658 1.29l28.31-1.395a3.18 3.18 0 00.085-6.35l-28.27-2.15c-.13-.01-.26-.015-.39-.015h.005z"
      ></path>
      <path
        fill="#F4A28C"
        d="M65.2 16.88c-6.94-5.82-17.2 1.62-13.665 9.95.07.16.145.32.22.5 3.7 7.78 15.94 19.906 15.94 19.906L54.055 63.85l3.93 2.785L73.545 54a11 11 0 003.825-10.86C75.665 35.246 72 22.576 65.2 16.88z"
      ></path>
      <path
        fill="#245B5B"
        d="M54.056 63.836s-5.815 2.855-4.3 5.24c1.515 2.385 4.615 4.705 8.23-2.455l-3.93-2.785z"
      ></path>
      <path
        fill="#F4A28C"
        d="M99.046 46.41s3.925 10.26-3 11.685c-4.376.895-9.86 4.76-13.306 7.5a7.61 7.61 0 00-2.844 6.875l1.394 11.695-4.06.945-3.53-10.645a15.425 15.425 0 014.8-16.75l5.91-4.9 14.636-6.405z"
      ></path>
      <path
        fill="#245B5B"
        d="M83.824 53.06l15.22-6.65S105.154 57.3 94 59.255c0 0-8.325 3.44-9.88 6l-7.705-6.5a20.998 20.998 0 017.41-5.695zM81.7 95.03a1.945 1.945 0 100-3.89 1.945 1.945 0 000 3.89z"
      ></path>
      <path
        fill={colorPrimaryMain}
        d="M77.35 84.844s-.135 3.325-2.765 4.4c-2.63 1.075-2.5 3.94.14 3.865 2.64-.075 7.925-5.16 7.925-5.16l-1.4-3.84-3.9.735z"
      ></path>
      <path
        fill="#FFD200"
        d="M83.3 87.745l-7.548 5.02 1.62 2.436 7.548-5.02-1.62-2.436z"
      ></path>
      <path fill="#E6E6E6" d="M31.29 25.6H.95v15.49h30.34V25.6z"></path>
      <path
        fill="#A5A5A5"
        d="M12 31.956a3.03 3.03 0 10-5.616 1.575L9 37.766l2.575-4.215A3.044 3.044 0 0012 31.956zM9 33.56a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
      ></path>
      <path
        fill="#A5A5A5"
        d="M26.38 29.77H15.39v2.19h10.99v-2.19z"
        opacity="0.58"
      ></path>
      <path
        fill="#A5A5A5"
        d="M26.38 33.895H15.39v2.19h10.99v-2.19z"
        opacity="0.23"
      ></path>
      <path
        fill="#FFD200"
        d="M27.682 52.548l-10.188-5.335-3.11 5.94 10.187 5.335 3.11-5.94z"
      ></path>
    </svg>
  );
};

Cycling.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Cycling;
